{
  "familyId": "GET-PROC-BTW",
  "questions": [
    {
      "id": "GET-PROC-BTW-001",
      "familyId": "GET-PROC-BTW",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_btw_excl",
      "questionType": "fill_in",
      "question": "Een boekhouder vergelijkt twee facturen voor dezelfde dienst. Factuur A toont €211,75 inclusief 21% BTW, factuur B toont €175 zonder BTW-vermelding. Ze wil controleren of beide facturen hetzelfde bedrag exclusief BTW gebruiken. Wat is de prijs exclusief BTW van factuur A?",
      "data": {
        "acceptedAnswers": ["175", "€175", "€ 175", "175,00", "€175,00"],
        "unit": "€",
        "placeholder": "€ ..."
      },
      "correctAnswer": 0,
      "conceptId": "vat_exclusive_compare",
      "variantIndex": 1,
      "citoDifficulty": 0.58,
      "citoDiscrimination": 0.76,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "get.btw-trekken-procent", "label": "BTW als 21%-aftrek van inclusief" }
        ]
      },
      "stimulusAids": [
        {
          "type": "percentageBar",
          "showWhen": "always",
          "data": {
            "percentage": 21,
            "label": "Factuur A: 21% BTW op €175 → €36,75 BTW → €211,75 inclusief",
            "showValue": true
          },
          "a11y": { "alt": "Percentagebalk: 21% BTW boven op €175" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "BTW als 121 delen denken",
            "content": "Stel de hele strook voor als 121 gelijke delen: 100 delen = prijs exclusief (€175), 21 delen = BTW (€36,75). Vergelijking: factuur B is €175, dus beide facturen hebben dezelfde prijs exclusief.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Twee facturen vergelijken: factuur A is €211,75 inclusief 21% BTW. Bereken eerst exclusief: €211,75 ÷ 1,21 = €175. Vergelijk met factuur B (€175 zonder BTW-vermelding) — beide facturen gebruiken dus dezelfde prijs exclusief BTW. Let op: 21% van €211,75 aftrekken klopt niet. Je berekent de BTW over de prijs exclusief (€175), niet over inclusief (€211,75). Controle: €175 × 1,21 = €211,75 ✓.",
        "solutionSteps": [
          "Lees factuur A: €211,75 inclusief 21% BTW",
          "Prijs exclusief = inclusief ÷ 1,21 = €211,75 ÷ 1,21 = €175",
          "Vergelijk met factuur B: €175 — dezelfde prijs exclusief",
          "Controle: €175 × 1,21 = €211,75 ✓",
          "Conclusie: beide facturen gebruiken €175 exclusief BTW"
        ],
        "distractorExplanations": {}
      }
    },
    {
      "id": "GET-PROC-BTW-002",
      "familyId": "GET-PROC-BTW",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_btw_excl",
      "questionType": "multiple_choice",
      "question": "Een ondernemer koopt kantoorspullen voor €121 inclusief 21% BTW. Hoeveel is het BTW-bedrag?",
      "options": ["€21", "€25,41", "€100", "€10"],
      "correctAnswer": 0,
      "conceptId": "vat_amount_calculation",
      "variantIndex": 2,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.73,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "get.btw-procent-van-inclusief", "label": "21% van inclusief-prijs", "optionIndex": 1 },
          { "id": "get.btw-excl-als-btw-bedrag", "label": "Prijs exclusief verward met BTW-bedrag", "optionIndex": 2 },
          { "id": "get.btw-rekenfout", "label": "Rekenfout", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "percentageBar",
          "showWhen": "always",
          "data": {
            "percentage": 21,
            "label": "21% BTW op €100 → €21 BTW → €121 inclusief",
            "showValue": true
          },
          "a11y": { "alt": "Percentagebalk: 21% BTW boven op €100" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "BTW als 121 delen denken",
            "content": "Stel €121 voor als 121 gelijke delen: 100 delen = €100 exclusief, 21 delen = €21 BTW. Samen: €100 + €21 = €121.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De ondernemer wil weten hoeveel BTW er in de prijs zit. Stap 1: prijs exclusief BTW = €121 ÷ 1,21 = €100. Stap 2: BTW = €121 − €100 = €21. Je kunt het ook checken: €100 × 0,21 = €21. Let op de veelgemaakte fout: 21% van €121 = €25,41 — maar dat is fout! De BTW is berekend over de prijs exclusief (€100), niet over de prijs inclusief (€121).",
        "solutionSteps": [
          "Prijs exclusief = €121 ÷ 1,21 = €100",
          "BTW-bedrag = inclusief − exclusief",
          "BTW = €121 − €100 = €21",
          "Of: BTW = €100 × 0,21 = €21 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Exclusief = €121 ÷ 1,21 = €100. BTW = €121 − €100 = €21.",
          "1": "Je dacht waarschijnlijk dat je 21% van €121 berekent: €121 × 0,21 = €25,41. Maar 21% BTW is over de prijs exclusief, niet over de prijs inclusief. Onthoud: eerst delen door 1,21, dan het verschil berekenen.",
          "2": "Je verwart de prijs exclusief BTW met het BTW-bedrag. €100 is de prijs exclusief BTW, niet het BTW-bedrag. Onthoud: BTW = inclusief − exclusief = €121 − €100 = €21.",
          "3": "Je hebt waarschijnlijk een rekenfout gemaakt. Bereken eerst exclusief: €121 ÷ 1,21 = €100. BTW = €21."
        }
      }
    },
    {
      "id": "GET-PROC-BTW-003",
      "familyId": "GET-PROC-BTW",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_btw_excl",
      "questionType": "fill_in",
      "question": "Een accountant controleert een factuur van €278,30 inclusief 21% BTW. Wat is de prijs exclusief BTW?",
      "data": {
        "acceptedAnswers": ["230", "€230", "€ 230", "230,00", "€230,00"],
        "unit": "€",
        "placeholder": "€ ..."
      },
      "correctAnswer": 0,
      "conceptId": "vat_exclusive_uneven",
      "variantIndex": 3,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "get.btw-trekken-procent", "label": "BTW als 21%-aftrek i.p.v. delen door 1,21" }
        ]
      },
      "stimulusAids": [
        {
          "type": "percentageBar",
          "showWhen": "always",
          "data": {
            "percentage": 21,
            "label": "21% BTW op €230 → €48,30 BTW → €278,30 inclusief",
            "showValue": true
          },
          "a11y": { "alt": "Percentagebalk: 21% BTW boven op €230" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "BTW als 121 delen denken",
            "content": "Stel €278,30 voor als 121 gelijke delen: 100 delen = €230 exclusief, 21 delen = €48,30 BTW. Samen: €230 + €48,30 = €278,30.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Deel het totaalbedrag door 1,21: €278,30 ÷ 1,21 = €230. Controleer altijd je antwoord door terug te rekenen: €230 × 1,21 = €278,30 ✓. Je kunt ook stap voor stap controleren: €230 × 0,21 = €48,30 BTW. €230 + €48,30 = €278,30 ✓.",
        "solutionSteps": [
          "Exclusief = inclusief ÷ 1,21",
          "€278,30 ÷ 1,21 = €230",
          "Controleer: €230 × 1,21 = €278,30 ✓",
          "Of: €230 × 0,21 = €48,30 BTW, €230 + €48,30 = €278,30 ✓"
        ],
        "distractorExplanations": {}
      }
    },
    {
      "id": "GET-PROC-BTW-004",
      "familyId": "GET-PROC-BTW",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_btw_excl",
      "questionType": "multiple_choice",
      "question": "Een zzp'er offreert een klant: 5 uur werk à €70 exclusief BTW, plus €30 reiskosten exclusief BTW. Over alles geldt 21% BTW. Hoeveel betaalt de klant in totaal inclusief BTW?",
      "options": ["€459,80", "€380", "€453,50", "€504,90"],
      "correctAnswer": 0,
      "conceptId": "vat_multi_component_analysis",
      "variantIndex": 4,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "get.btw-deeltotaal-als-eind", "label": "Subtotaal exclusief als eindbedrag", "optionIndex": 1 },
          { "id": "get.btw-percentage-als-bedrag", "label": "BTW alleen over uurloon, reiskosten vergeten", "optionIndex": 2 },
          { "id": "get.btw-tarief-verwisseld", "label": "BTW twee keer berekend / verkeerd tarief", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "percentageBar",
          "showWhen": "always",
          "data": {
            "percentage": 21,
            "label": "21% BTW op €380 (uurloon + reiskosten) → €79,80 BTW → €459,80 inclusief",
            "showValue": true
          },
          "a11y": { "alt": "Percentagebalk: 21% BTW boven op €380 subtotaal" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Subtotaal × 1,21",
            "content": "Eerst alles exclusief optellen: 5 × €70 + €30 = €380. Dan inclusief: €380 × 1,21 = €459,80 (100 delen exclusief + 21 delen BTW).",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Meerdere posten combineren. Stap 1: alles exclusief BTW optellen: 5 uur × €70 = €350 uurloon, plus €30 reiskosten = €380 subtotaal exclusief. Stap 2: BTW over het totaal: €380 × 0,21 = €79,80. Stap 3: inclusief = €380 + €79,80 = €459,80 (of korter: €380 × 1,21 = €459,80). Belangrijke valkuilen: vergeet de reiskosten niet bij de BTW-grondslag, en bereken de BTW pas over het volledige subtotaal — niet per post apart.",
        "solutionSteps": [
          "Uurloon exclusief: 5 × €70 = €350",
          "Subtotaal exclusief: €350 + €30 reiskosten = €380",
          "BTW: €380 × 0,21 = €79,80",
          "Inclusief: €380 + €79,80 = €459,80",
          "Controle: €380 × 1,21 = €459,80 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Subtotaal €380 × 1,21 = €459,80 inclusief.",
          "1": "Je hebt het subtotaal exclusief BTW (€380) als eindbedrag genomen. Maar de klant betaalt inclusief BTW: €380 × 1,21 = €459,80. Onthoud: tel altijd de BTW erbij op.",
          "2": "Je hebt de BTW alleen over het uurloon berekend (€350 × 1,21 = €423,50) en de reiskosten (€30) er los bij opgeteld. BTW geldt over alle posten samen: €380 × 1,21 = €459,80.",
          "3": "Je hebt een verkeerd tarief gebruikt of een rekenfout gemaakt. Het juiste antwoord is €380 × 1,21 = €459,80. Onthoud: BTW bereken je één keer over het totaal exclusief."
        }
      }
    },
    {
      "id": "GET-PROC-BTW-005",
      "familyId": "GET-PROC-BTW",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_btw_excl",
      "questionType": "multiple_choice",
      "question": "Een winkelier verkoopt een gemengde bestelling: een boek van €27,25 inclusief 9% BTW en kantoorspullen voor €60,50 inclusief 21% BTW. Hoeveel BTW heeft de klant in totaal betaald?",
      "options": ["€12,75", "€18,38", "€10,50", "€7,90"],
      "correctAnswer": 0,
      "conceptId": "vat_mixed_rates_analysis",
      "variantIndex": 5,
      "citoDifficulty": 0.58,
      "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "get.btw-een-tarief-voor-alles", "label": "Eén tarief op alles toegepast i.p.v. per product", "optionIndex": 1 },
          { "id": "get.btw-deeltotaal-als-eind", "label": "Alleen BTW van één product berekend", "optionIndex": 2 },
          { "id": "get.btw-tarief-verwisseld", "label": "Verkeerde tarieven gekoppeld aan producten", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "percentageBar",
          "showWhen": "always",
          "data": {
            "percentage": 9,
            "comparePercentage": 21,
            "percentageLabel": "Boek: 9% BTW",
            "compareLabel": "Kantoor: 21% BTW",
            "showValue": true,
            "label": "Twee tarieven naast elkaar"
          },
          "a11y": { "alt": "Percentagebalk: 9% naast 21% — gemengde tarieven" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Twee tarieven, twee berekeningen",
            "content": "Boek (9% BTW): €27,25 ÷ 1,09 = €25 excl → BTW €2,25. Kantoor (21% BTW): €60,50 ÷ 1,21 = €50 excl → BTW €10,50. Samen: €2,25 + €10,50 = €12,75 BTW.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Producten hebben verschillende BTW-tarieven, dus je moet ze apart berekenen. Boek (9% BTW): exclusief = €27,25 ÷ 1,09 = €25, BTW = €27,25 − €25 = €2,25. Kantoor (21% BTW): exclusief = €60,50 ÷ 1,21 = €50, BTW = €60,50 − €50 = €10,50. Totale BTW = €2,25 + €10,50 = €12,75. Let op: voedsel/boeken hebben 9% BTW, kantoorartikelen 21%. Je mag NIET één tarief op alles toepassen.",
        "solutionSteps": [
          "Herken twee tarieven: boek 9%, kantoor 21%",
          "Boek exclusief: €27,25 ÷ 1,09 = €25 → BTW €2,25",
          "Kantoor exclusief: €60,50 ÷ 1,21 = €50 → BTW €10,50",
          "Totale BTW: €2,25 + €10,50 = €12,75",
          "Controle: €25 × 0,09 + €50 × 0,21 = €2,25 + €10,50 = €12,75 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Twee tarieven apart: €2,25 + €10,50 = €12,75 BTW totaal.",
          "1": "Je hebt waarschijnlijk 21% op het hele bedrag (€87,75) toegepast: €87,75 × 0,21 ≈ €18,38. Maar het boek heeft 9% BTW, niet 21%. Onthoud: verschillende producten kunnen verschillende BTW-tarieven hebben en moeten apart berekend worden.",
          "2": "Je hebt waarschijnlijk alleen de BTW van het kantoorartikel berekend (€10,50) en het boek vergeten. De totale BTW = boek-BTW (€2,25) + kantoor-BTW (€10,50) = €12,75. Onthoud: tel BTW van alle producten op.",
          "3": "Je hebt waarschijnlijk de tarieven omgewisseld (21% op het boek, 9% op kantoor) of een rekenfout gemaakt. Onthoud: boeken/voedsel = 9% BTW, kantoor/elektronica = 21% BTW. Het juiste totaal is €12,75."
        }
      }
    },
    {
      "id": "GET-PROC-BTW-006",
      "familyId": "GET-PROC-BTW",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_btw_excl",
      "questionType": "multiple_choice",
      "question": "Een loodgieter stuurt een rekening van €344,85 inclusief 21% BTW. Hoeveel BTW heeft de klant betaald?",
      "options": ["€59,85", "€72,42", "€51,73", "€86,21"],
      "correctAnswer": 0,
      "conceptId": "vat_amount_from_inclusive",
      "variantIndex": 6,
      "citoDifficulty": 0.58,
      "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "get.btw-procent-van-inclusief", "label": "21% van inclusief", "optionIndex": 1 },
          { "id": "get.btw-trekken-procent", "label": "Verkeerde formule (delen door 1,21 vergeten)", "optionIndex": 2 },
          { "id": "get.btw-tarief-verwisseld", "label": "25% i.p.v. 21% gebruikt", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "percentageBar",
          "showWhen": "always",
          "data": {
            "percentage": 21,
            "label": "21% BTW op €285 → €59,85 BTW → €344,85 inclusief",
            "showValue": true
          },
          "a11y": { "alt": "Percentagebalk: 21% BTW boven op €285" }
        }
      ],
      "supportAids": [
        {
          "type": "percentageBar",
          "showWhen": "wrong",
          "data": {
            "percentage": 21,
            "label": "€344,85 inclusief = 100% exclusief (€285) + 21% BTW (€59,85)",
            "showValue": true
          },
          "a11y": { "alt": "Percentagebalk: 21% BTW boven op €285 exclusief" }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "BTW als 121 delen denken",
            "content": "Stel €344,85 voor als 121 gelijke delen: 100 delen = €285 exclusief, 21 delen = €59,85 BTW. Samen: €285 + €59,85 = €344,85.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Je wilt weten hoeveel BTW er in de rekening zit. Stap 1: prijs exclusief = €344,85 ÷ 1,21 = €285. Stap 2: BTW = €344,85 − €285 = €59,85. Check: €285 × 0,21 = €59,85 ✓. Let op: 21% van €344,85 = €72,42 — dat is niet het juiste BTW-bedrag, want de BTW is berekend over €285 (exclusief), niet over €344,85 (inclusief). Reken altijd terug door te delen door 1,21.",
        "solutionSteps": [
          "Prijs exclusief = €344,85 ÷ 1,21 = €285",
          "BTW = inclusief − exclusief",
          "BTW = €344,85 − €285 = €59,85",
          "Of: BTW = €285 × 0,21 = €59,85 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Exclusief = €344,85 ÷ 1,21 = €285. BTW = €344,85 − €285 = €59,85.",
          "1": "Je dacht waarschijnlijk dat je 21% van €344,85 berekent: €344,85 × 0,21 = €72,42. Maar 21% BTW is over de prijs exclusief (€285), niet over de prijs inclusief. Onthoud: eerst delen door 1,21.",
          "2": "Je hebt waarschijnlijk een verkeerde formule gebruikt of een rekenfout gemaakt. De juiste methode: €344,85 ÷ 1,21 = €285 exclusief, dan BTW = €344,85 − €285 = €59,85.",
          "3": "Je hebt waarschijnlijk een verkeerd tarief gebruikt (25% i.p.v. 21%). Onthoud: het standaard BTW-tarief in Nederland is 21%, niet 25%. Het juiste BTW-bedrag is €59,85."
        }
      }
    },
    {
      "id": "GET-PROC-BTW-007",
      "familyId": "GET-PROC-BTW",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_btw_excl",
      "questionType": "multiple_choice",
      "question": "Een webdesigner werkt 8 uur tegen €75 per uur exclusief BTW. Ze rekent ook €40 hostingkosten inclusief 21% BTW door. Hoeveel betaalt de klant in totaal?",
      "options": ["€766", "€640", "€774,40", "€766,40"],
      "correctAnswer": 0,
      "conceptId": "vat_mixed_incl_excl_analysis",
      "variantIndex": 7,
      "citoDifficulty": 0.60,
      "citoDiscrimination": 0.71,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "get.btw-deeltotaal-als-eind", "label": "Subtotaal als eindbedrag, hosting vergeten", "optionIndex": 1 },
          { "id": "get.btw-tarief-verwisseld", "label": "BTW twee keer over hostingkosten", "optionIndex": 2 },
          { "id": "get.btw-percentage-als-bedrag", "label": "Rekenfout op laatste decimaal", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "percentageBar",
          "showWhen": "always",
          "data": {
            "percentage": 21,
            "label": "21% BTW op €600 uurloon → €726 inclusief, plus €40 hosting al inclusief = €766",
            "showValue": true
          },
          "a11y": { "alt": "Percentagebalk: 21% BTW boven op €600 uurloon" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Per post bekijken: incl of excl?",
            "content": "Uurloon (excl): 8 × €75 = €600 → ×1,21 = €726 inclusief BTW. Hosting is al inclusief: €40. Samen: €726 + €40 = €766. Tel geen BTW dubbel op de hosting.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Let goed op: uurloon is exclusief BTW, hosting is al inclusief BTW. Je mag GEEN BTW op de hosting optellen. Stap 1: uurloon exclusief = 8 × €75 = €600. Stap 2: uurloon inclusief = €600 × 1,21 = €726. Stap 3: hosting is al inclusief (€40), gewoon optellen. Totaal = €726 + €40 = €766. Veelgemaakte fout: ook BTW over de hostingkosten berekenen — die zit er al in.",
        "solutionSteps": [
          "Uurloon exclusief: 8 × €75 = €600",
          "Uurloon inclusief BTW: €600 × 1,21 = €726",
          "Hosting is al inclusief: €40 (niet nog eens × 1,21)",
          "Totaal: €726 + €40 = €766"
        ],
        "distractorExplanations": {
          "0": "Goed! Uurloon €600 × 1,21 = €726, plus hosting €40 inclusief = €766 totaal.",
          "1": "Je hebt het uurloon zonder BTW opgeteld bij de hostingkosten (€600 + €40 = €640). Onthoud: bereken eerst uurloon inclusief BTW (€726), tel dan hosting (€40 inclusief) erbij. Totaal: €766.",
          "2": "Je hebt de BTW ook over de hostingkosten berekend (€40 × 1,21 = €48,40). Onthoud: als een prijs al 'inclusief BTW' is, mag je er geen BTW meer bij optellen.",
          "3": "Je hebt een rekenfout gemaakt. Het juiste antwoord is precies €766: €600 × 1,21 = €726 exact, plus €40 = €766."
        }
      }
    },
    {
      "id": "GET-PROC-BTW-008",
      "familyId": "GET-PROC-BTW",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_btw_excl",
      "questionType": "multiple_choice",
      "question": "Een kapper betaalt €1.143,45 inclusief 21% BTW voor nieuwe apparatuur. Hoeveel kan de kapper aftrekken als BTW?",
      "options": ["€198,45", "€240,12", "€945", "€1.143,45"],
      "correctAnswer": 0,
      "conceptId": "vat_deduction",
      "variantIndex": 8,
      "citoDifficulty": 0.62,
      "citoDiscrimination": 0.71,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "get.btw-procent-van-inclusief", "label": "21% van inclusief", "optionIndex": 1 },
          { "id": "get.btw-excl-als-btw-bedrag", "label": "Prijs exclusief als BTW-bedrag", "optionIndex": 2 },
          { "id": "get.btw-deeltotaal-als-eind", "label": "Heel bedrag aangezien voor BTW", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "percentageBar",
          "showWhen": "always",
          "data": {
            "percentage": 21,
            "label": "21% BTW op €945 → €198,45 BTW → €1.143,45 inclusief",
            "showValue": true
          },
          "a11y": { "alt": "Percentagebalk: 21% BTW boven op €945" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "BTW als 121 delen denken",
            "content": "Stel €1.143,45 voor als 121 gelijke delen: 100 delen = €945 exclusief, 21 delen = €198,45 BTW. De ondernemer kan die €198,45 aftrekken.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De kapper kan de BTW aftrekken. Stap 1: prijs exclusief = €1.143,45 ÷ 1,21 = €945. Stap 2: BTW = €1.143,45 − €945 = €198,45. De kapper kan €198,45 aftrekken. Check: €945 × 0,21 = €198,45 ✓. Let op: 21% van €1.143,45 = €240,12 — dat is niet het juiste bedrag, want de BTW is berekend over €945 (exclusief). Reken altijd terug door te delen door 1,21.",
        "solutionSteps": [
          "Prijs exclusief = €1.143,45 ÷ 1,21 = €945",
          "BTW = inclusief − exclusief",
          "BTW = €1.143,45 − €945 = €198,45",
          "De kapper kan €198,45 aftrekken ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Exclusief = €1.143,45 ÷ 1,21 = €945. BTW = €1.143,45 − €945 = €198,45.",
          "1": "Je dacht waarschijnlijk dat je 21% van €1.143,45 berekent: €1.143,45 × 0,21 = €240,12. Maar 21% BTW is over de prijs exclusief (€945), niet over de prijs inclusief. Onthoud: eerst delen door 1,21.",
          "2": "Je verwart de prijs exclusief BTW met het BTW-bedrag. €945 is de prijs exclusief, niet de BTW. De BTW is €1.143,45 − €945 = €198,45.",
          "3": "Je dacht waarschijnlijk dat het hele bedrag als BTW afgetrokken kan worden. Maar €1.143,45 is de totaalprijs. Alleen de BTW (€198,45) kan worden afgetrokken."
        }
      }
    },
    {
      "id": "GET-PROC-BTW-009",
      "familyId": "GET-PROC-BTW",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_btw_excl",
      "questionType": "fill_in",
      "question": "Een fietsenmaker krijgt een rekening van €290,40 inclusief 21% BTW. Hoeveel euro BTW zit er in dit bedrag?",
      "data": {
        "acceptedAnswers": ["50,40", "€50,40", "€ 50,40", "50.40", "€50.40"],
        "unit": "€",
        "placeholder": "€ ..."
      },
      "correctAnswer": 0,
      "conceptId": "vat_amount_from_inclusive",
      "variantIndex": 9,
      "citoDifficulty": 0.62,
      "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "get.btw-procent-van-inclusief", "label": "21% van inclusief i.p.v. terugrekenen naar exclusief" }
        ]
      },
      "stimulusAids": [
        {
          "type": "percentageBar",
          "showWhen": "always",
          "data": {
            "percentage": 21,
            "label": "€290,40 inclusief = €240 excl. + €50,40 BTW",
            "showValue": true
          },
          "a11y": { "alt": "Percentagebalk: 21% BTW boven €240 exclusief" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "BTW uit een inclusief bedrag halen",
            "content": "Bij 21% BTW geldt: inclusief = exclusief × 1,21. Reken dus eerst terug naar exclusief (€290,40 ÷ 1,21 = €240), en trek dat af van het inclusieve bedrag: €290,40 − €240 = €50,40 BTW. Niet: 21% van €290,40 nemen — dat is een veelgemaakte fout.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Bij 21% BTW staat €290,40 inclusief gelijk aan €240 exclusief plus €50,40 BTW. Reken terug van inclusief naar exclusief (€290,40 ÷ 1,21 = €240), trek af (€290,40 − €240 = €50,40). Veelgemaakte fout: 21% van €290,40 nemen geeft €60,98 — dat is fout omdat BTW over de exclusieve prijs (€240) berekend is, niet over de inclusieve (€290,40). Controle: €240 × 1,21 = €290,40 ✓.",
        "solutionSteps": [
          "Lees: €290,40 inclusief 21% BTW",
          "Reken exclusief: €290,40 ÷ 1,21 = €240",
          "BTW = inclusief − exclusief = €290,40 − €240 = €50,40",
          "Controle: €240 × 1,21 = €290,40 ✓"
        ],
        "distractorExplanations": {}
      }
    }
  ]
}